import { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { setRecoveryEmail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export const RecoveryEmailRow = ({ hint, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await setRecoveryEmail(email);
      toast.success(r.recovery_email ? `Recovery email set to ${r.recovery_email_hint}` : "Recovery email cleared");
      setEditing(false);
      setEmail("");
      await onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-6" data-testid="recovery-email-section">
      <h4 className="text-xs uppercase tracking-wider font-mono text-muted-foreground flex items-center gap-1.5 mb-2">
        <MailCheck className="h-3.5 w-3.5" /> PIN recovery email
      </h4>
      {editing ? (
        <div className="flex items-center gap-2">
          <Input data-testid="recovery-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="bg-card h-9" autoFocus />
          <Button data-testid="recovery-email-save-btn" size="sm" onClick={save} disabled={busy}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save"}
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setEditing(false)}>
            Cancel
          </Button>
        </div>
      ) : (
        <div className="flex items-center justify-between rounded-lg border border-border bg-card px-3 py-2 text-sm">
          <span data-testid="recovery-email-hint" className={hint ? "" : "text-muted-foreground"}>
            {hint || "Not set — add one so you can reset a forgotten PIN by email"}
          </span>
          <button data-testid="recovery-email-edit-btn" onClick={() => setEditing(true)} className="text-xs text-primary hover:underline">
            {hint ? "Change" : "Add"}
          </button>
        </div>
      )}
    </div>
  );
};
